<div class="empty-state">
  @if (recent().length > 0) {
    <p class="section-label">Zuletzt gesucht</p>
    <div class="recent-chips">
      @for (term of recent(); track term) {
        <button type="button" class="recent-chip" (click)="recentSelected.emit(term)">
          <app-icon alt="" [ariaHidden]="true" src="search.svg" [height]="14" [width]="14" className="chip-icon" />
          {{ term }}
        </button>
      }
    </div>
  }
  <p class="section-label">Vorschläge</p>
  <div class="suggestions-list">
    @for (suggestion of suggestions(); track suggestion.label) {
      <button type="button" class="suggestion-row click-animation" (click)="suggestionSelected.emit(suggestion)">
        <span class="suggestion-icon-tile">
          <app-icon [alt]="suggestion.label" [src]="suggestion.icon" [height]="20" [width]="20" className="suggestion-icon" />
        </span>
        <span class="suggestion-text">
          <span class="suggestion-title">{{ suggestion.label }}</span>
          <span class="suggestion-subtitle">{{ suggestion.subtitle }}</span>
        </span>
        <app-icon alt="" [ariaHidden]="true" src="chevron-right.svg" [height]="18" [width]="18" className="suggestion-chevron" />
      </button>
    }
  </div>
</div>
